// Cadastro de cliente da Base clientes (novo / editar). Usado na Base clientes e no card
// ("+ Cadastrar na base" quando a conta não é localizada). Não importa ./comum (evita ciclo).
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, MenuItem, TextField, Typography,
} from "@material-ui/core";

import suporteApi, { mensagemErro } from "./api";

export const SITUACOES = ["ATIVO", "CANCELADO", "IMPLANTAÇÃO", "IMPLANTAÇÃO | AGUARDANDO FICHA"];

// ------------------------------------------------------------------ cadastro (editar / novo)
const CAMPOS = [
  ["conta", "Conta", "text", true], ["status", "Situação", SITUACOES, true],
  ["nome", "Nome / Filial", "text", true, 12], ["grupo", "Grupo de cliente"], ["sap", "SAP"],
  ["codigo", "Código"], ["loja", "Loja"], ["cnpj", "CNPJ"], ["endereco", "Endereço", "text", false, 12],
  ["bairro", "Bairro"], ["cidade", "Cidade"], ["uf", "UF", ["", "AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO",
    "MA", "MG", "MS", "MT", "PA", "PB", "PE", "PI", "PR", "RJ", "RN", "RO", "RR", "RS", "SC", "SE", "SP", "TO"]],
  ["cep", "CEP"], ["regiao", "Região"],
  ["modelo", "Modelo (central/DVR)"], ["marca", "Marca"], ["mac", "MAC"], ["funcionamento", "Funcionamento"],
  ["data_habilitado", "Data habilitado", "date"], ["data_desabilitado", "Data desabilitado", "date"],
  ["data_criacao", "Data de criação", "date"],
  ["chip_qtd", "Chips instalados", ["", "1 – Chip instalado", "2 – Chips instalados", "Não possui chip instalado"]],
  ["chip_iccid1", "ICCID chip 1"], ["chip_iccid2", "ICCID chip 2"],
  ["observacao", "Observação", "textarea"],
];

export const FormCadastro = ({ registro, onClose, onSalvo }) => {
  const [f, setF] = useState({});
  const [salvando, setSalvando] = useState(false);
  useEffect(() => {
    if (registro) setF({ ...registro });
  }, [registro]);
  if (!registro) return null;

  const salvar = async () => {
    const dados = {};
    CAMPOS.forEach(([nome]) => {
      const v = f[nome];
      dados[nome] = v === "" || v === undefined ? null : v;
    });
    setSalvando(true);
    try {
      const { data } = registro.id
        ? await suporteApi.put(`/api/clientes/${registro.id}`, dados)
        : await suporteApi.post("/api/clientes", dados);
      toast.success("Cadastro salvo");
      onSalvo(data);
      onClose();
    } catch (err) {
      toast.error(mensagemErro(err));
    }
    setSalvando(false);
  };

  return (
    <Dialog open onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{registro.id ? `Editar cliente ${registro.conta}` : "Novo cliente"}</DialogTitle>
      <DialogContent>
        <Grid container spacing={1}>
          {CAMPOS.map(([nome, rotulo, tipo = "text", obrig = false, largura]) => (
            <Grid item xs={12} sm={largura || (tipo === "textarea" ? 12 : 6)} key={nome}>
              <TextField
                label={rotulo} required={obrig} fullWidth size="small" variant="outlined" margin="dense"
                value={f[nome] ?? ""} onChange={(e) => setF({ ...f, [nome]: e.target.value })}
                select={Array.isArray(tipo)}
                type={Array.isArray(tipo) || tipo === "textarea" ? undefined : tipo}
                multiline={tipo === "textarea"} rows={tipo === "textarea" ? 2 : undefined}
                InputLabelProps={tipo === "date" ? { shrink: true } : undefined}
              >
                {Array.isArray(tipo) && tipo.map((o) => <MenuItem key={o} value={o}>{o || "—"}</MenuItem>)}
              </TextField>
            </Grid>
          ))}
        </Grid>
        {registro.id && (
          <Typography variant="caption" color="textSecondary">
            {`Última alteração: ${registro.atualizado_por || "-"} em ${registro.atualizado_em ? new Date(registro.atualizado_em).toLocaleString("pt-BR") : "-"}`}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button color="primary" variant="contained" onClick={salvar} disabled={salvando}>Salvar</Button>
      </DialogActions>
    </Dialog>
  );
};

